<template>
  <v-dialog v-model="dialog" width="550">
    <template v-slot:activator="{}">
      <BaseButton
        v-if="create"
        @click="openModal"
        :text="
          localStorage.translations.pages.personnel_department[
            'employees_group-dialog-additional_project-buttons'
          ].add
        "
        default_icon="button-add"
      />
      <EditBtn v-else :openModal="openModal" />
    </template>
    <transition :duration="150">
      <EmployeesGroupSelectModalWorkTypeExtraForm
        v-if="dialog"
        @input="dialog = false"
        :id="id"
        :dialog="dialog"
        :closeModal="closeModal"
        :create="create"
        :item="item"
      />
    </transition>
  </v-dialog>
</template>

<script>
import EditBtn from 'components/EditBtn'
import EmployeesGroupSelectModalWorkTypeExtraForm from 'components/employees/group/select/EmployeesGroupSelectModalWorkTypeExtraForm'

export default {
  name: 'EmployeesGroupSelectModalWorkTypeExtra',
  components: { EmployeesGroupSelectModalWorkTypeExtraForm, EditBtn },
  props: ['id', 'create', 'minimalize', 'projectWorkTypeId', 'item'],
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    openModal() {
      this.dialog = true
    },
    closeModal() {
      this.dialog = false
    },
  },
}
</script>

<style lang="scss" scoped></style>
